import onNewValue from '../chains/onNewValue'
import onBackSpace from '../chains/onBackSpace'
import onDeselectTag from '../chains/onDeselectTag'
import onChangeValue from '../chains/onChangeValue'
import onFocusInput from '../chains/onFocusInput'
import onLeftTag from '../chains/onLeftTag'
import onRightTag from '../chains/onRightTag'
import onSelectOption from '../chains/onSelectOption'
import setFocusedOption from '../chains/setFocusedOption'
import onUpKey from '../chains/onUpKey'
import onDownKey from '../chains/onDownKey'
import onDeleteTagLeave from '../chains/onDeleteTagLeave'
import setOptionsClosed from '../chains/setOptionsClosed'
import setBlurInput from '../chains/setBlurInput'
import unFocusOption from '../chains/unFocusOption'
import onDeleteTagEnter from '../chains/onDeleteTagEnter'
import setFocusInput from '../chains/setFocusInput'
import unFlashTag from '../chains/unFlashTag'
import onTabKey from '../chains/onTabKey'
import init from '../chains/init'
import defaultState from '../state/defaultState'
import filterOptions from '../helpers/filterOptions'

const Selectr = ({ hooks }) => {
  return {
    signals: {
      init,
      onNewValue: onNewValue({
        onOptionCreated: hooks.onOptionCreated ? hooks.onOptionCreated : [],
        onSelectOption: hooks.onSelectOption ? hooks.onSelectOption : []
      }),
      onFocusInput,
      onChangeValue,
      onSelectOption: onSelectOption({
        onSelectOption: hooks.onSelectOption ? hooks.onSelectOption : []
      }),
      onDeselectTag: onDeselectTag({
        unSelectOption: hooks.unSelectOption ? hooks.unSelectOption : []
      }),
      setFocusedOption,
      setBlurInput,
      unFocusOption,
      onDeleteTagEnter,
      onDeleteTagLeave,
      unFlashTag,
      onDownKey,
      onUpKey,
      onLeftTag,
      onRightTag,
      onTabKey,
      onBackSpace: onBackSpace({
        unSelectOption: hooks.unSelectOption ? hooks.unSelectOption : []
      }),
      setFocusInput,
      setOptionsClosed
    },
    state: {}
  }
}

export default Selectr
